import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  getClientBackGroundRequest,
  getClientBackGroundSuccess,
  getClientBackGroundFailure,
} from '../reducers/view';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* getClientBackGroundAxios() {
  const state = yield select(fullState => fullState);
  const { userId: clientId } = state.loginReducer.user;
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${clientId}/background`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* getClientBackGroundSaga() {
  try {
    const response = yield call(getClientBackGroundAxios);

    const responseFromMessageContent = response.data.data.background;
    yield put(getClientBackGroundSuccess(responseFromMessageContent));
  } catch (error) {
    yield put(getClientBackGroundFailure(error));
  }
}

export function* watcherGetClientBackGroundSaga() {
  yield takeLatest(getClientBackGroundRequest().type, getClientBackGroundSaga);
}
